import React, { Fragment } from 'react';
import Img from './image1.jpg'
const About = () => {
  return (
    <Fragment>
      <h1>About This App</h1>
      <p>This is a React App to search Github users and get the details.</p>
      <p>Created by <strong>Mr. Afroz Alam</strong> @ Version: 1.0.0</p>
      <img src={Img} alt="img" style={{width:'200px', height:'200px', borderRadius: '50%'}}/>
      <p>Google: afrozalam8425website
      <br/>Email: afrozalam8425@gmail.com
      <br/>Mobile: +91 9680704264
      <br/><a href="https://afrozalam8425website.netlify.app/">https://afrozalam8425website.netlify.app/</a>
      </p>
    </Fragment>
  );
};

export default About;
